import React from 'react';
import { Field, ErrorMessage } from 'formik';
import { TextError } from 'components/FormikComponents';
import { format } from 'date-fns';


export const getFieldProps = (fieldName, editableFields, statusField = null, additionalProps = {}) => {
  let isEditable = null;
  isEditable = editableFields[fieldName];

  if(fieldName === 'accrualTarget' && statusField?.value === 'OPEN' && editableFields[fieldName]) {
    isEditable = true;
  }
  return {
    readOnly: !isEditable,
    className: !isEditable ? "bg-grey-disabled-light" : "",
    ...additionalProps
  };
};

// Custom Field wrapper component
export const EditableField = ({ editableFields, name, type, showError = false, statusField, length, ...props }) => {
  const isEditable = editableFields[name];

  return (
    <>
      <Field
        id={name}
        name={name}
        type={type}
        {...getFieldProps(name, editableFields, statusField)}
        {...props}
      />
     
      {showError && isEditable ? (
        <ErrorMessage name={name} component={TextError} />
      ) : (
        <div style={{height:"12px"}} />
      )}
    </>
  );
};


export const FormFieldCell = ({ fieldName, label, children }) => (
  <td>
    <label className="invisible" htmlFor={fieldName}>
      {label || fieldName}
    </label>
    <div className="form-layout-wrapper bg-transparent position-relative">
      <div className="form-input-wrapper">
        {children}
      </div>
    </div>
  </td>
);


export const getTodayFormatted = () => {
  const today = new Date();
  const formattedDate = format(today, "dd-MMM-yyyy");
  return formattedDate;
}